import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  optionschoose,
  optionsource,
  optionssymbol,
} from "../../core/common/selectoption/selectoption";
import { leadsData } from "../../core/data/json/leads";
import { Modal } from "react-bootstrap";
import { TableData } from "../../core/data/interface";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CollapseHeader from "../../core/common/collapse-header";
import { SelectWithImage2 } from "../../core/common/selectWithImage2";
import { all_routes } from "../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from "react-bootstrap/Offcanvas";
const Modules = () => {
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      width: "50px",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "92px",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Component",
      dataIndex: "component",
      key: "component",
      width: "202px",
      render: (text: any) => (
        <Link to={route.leadsactivity} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.lead_name.length - b.lead_name.length,
    },
    {
      title: "Attribute",
      dataIndex: "attribute",
      key: "attribute",
      width: "392px",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },

    {
      title: "Status",
      dataIndex: "status",
      width: "90px",
      render: (text: string) => (
        <div>
          {text === "Closed" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}
          {text === "Connected" && (
            <span className="badge badge-pill badge-status bg-warning">
              {text}
            </span>
          )}
          {text === "Lost" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
          {text === "Not connected" && (
            <span className="badge badge-pill badge-status bg-pending">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
                            data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
               data-bs-toggle="modal"
              data-bs-target="#delete_calls"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>

            <Link className="dropdown-item" to="#">
              <i className="ti ti-clipboard-copy text-blue-light" /> clone
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Modules List <span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <Link
                            to="#"
                            className="btn btn-primary"
                            data-bs-target="#offcanvas_add"
                            data-bs-toggle="offcanvas"
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Module
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                    {/* Contact List */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={data} columns={columns} />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Company */}
        <div
          className="offcanvas  "
          style={{ width: "650px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Add Module</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Name </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Components</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Attribute</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Order</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Is Active</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select id="multiple_labels" className="form-select">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  onClick={() => setOpenModal2(true)}
                >
                  Save
                </button>
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="offcanvas"
                >
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </div>
        {/* /Add Company */}
        {/* Edit Calls */}
        <div
          className="offcanvas "
          style={{ width: "650px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Edit Module</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Name </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                                                <label className="form-label">Components </label>
                                                        <div className="input-group" style={{marginBottom: '10px'}}>
                                                        <select name="components[]" id="components" className="form-control select2 select2-hidden-accessible"  aria-hidden="true">
                                                                                                                        <option  value="dashboard">Dashboard</option>
                                                                                                                        <option value="start-dialing">Start Dialing</option>
                                                                                                                        <option  value="manage-extensions">User Management</option>
                                                                                                                        <option  value="extension">Extension</option>
                                                                                                                        <option value="extension-group">Group</option>
                                                                                                                        <option  value="ring-group">Ring Groups</option>
                                                                                                                        <option value="manage-campaigns">Campaign</option>
                                                                                                                        <option value="extension_live">Agent Status</option>
                                                                                                                        <option value="campaign">Campaign</option>
                                                                                                                        <option value="disposition">Disposition</option>
                                                                                                                        <option value="sms-configuration">SMS Configuration</option>
                                                                                                                        <option value="sms-ai">SMS AI</option>
                                                                                                                        <option value="lead-management">Lead Management</option>
                                                                                                                        <option value="label">Label</option>
                                                                                                                        <option value="lead">Lead</option>
                                                                                                                        <option value="list">List</option>
                                                                                                                        <option value="recycle-rule">Recycle Rule</option>
                                                                                                                        <option value="lead-activity">Lead Activity</option>
                                                                                                                        <option value="custom-field-labels">Custom Field Label</option>
                                                                                                                        <option value="lead-source-configs">Lead Source</option>
                                                                                                                        <option  value="inbound-configuration">Inbound Setting</option>
                                                                                                                        <option  value="did">DID Configuration</option>
                                                                                                                        <option  value="did_call-timings-listing">Call Times</option>
                                                                                                                        <option  value="did_holidays">Holidays</option>
                                                                                                                        <option  value="ivr">IVR</option>
                                                                                                                        <option  value="ivr-menu">IVR Menu</option>
                                                                                                                        <option value="audio-message">Audio Message</option>
                                                                                                                        <option value="configuration">Configuration</option>
                                                                                                                        <option value="api-data">API</option>
                                                                                                                        <option value="voip-configurations">VoIP Configurations</option>
                                                                                                                        <option value="email-templates">Email Templates</option>
                                                                                                                        <option value="voice-templete">Voice Templates</option>
                                                                                                                        <option value="set-voicemail">Set VoiceMail Prompt</option>
                                                                                                                        <option value="ip-setting">IP Setting</option>
                                                                                                                        <option value="logo-setting">Notification Setting</option>
                                                                                                                        <option value="smtps">SMTP Setting</option>
                                                                                                                        <option value="custom-fields-values">Custom Fields Values</option>
                                                                                                                        <option value="flash-panel">Flash Panel</option>
                                                                                                                        <option value="allowed-ips">Allowed IPs</option>
                                                                                                                        <option  value="call-data-reports">Reports</option>
                                                                                                                        <option value="transfer-report">Call Transfer</option>
                                                                                                                        <option  value="live-call">Live Call</option>
                                                                                                                        <option value="press1-campaign">Ivr Logs</option>
                                                                                                                        <option  value="report">Call Data Reports</option>
                                                                                                                        <option  value="callback">Callback</option>
                                                                                                                        <option value="cli-report">CLI CNAM Reports</option>
                                                                                                                        <option value="transfer">Transfer</option>
                                                                                                                        <option value="count-list">Call Count Report</option>
                                                                                                                        <option value="login-history">Login History</option>
                                                                                                                        <option value="contact-crm">CRM</option>
                                                                                                                        <option value="leads">Leads</option>
                                                                                                                        <option value="sub-leads">Sub Leads</option>
                                                                                                                        <option value="lenders">Lenders</option>
                                                                                                                        <option value="lead-status">Lead Status</option>
                                                                                                                        <option value="crm-labels">Labels</option>
                                                                                                                        <option value="document-types">Document Types</option>
                                                                                                                        <option value="lead-source">Lead Source</option>
                                                                                                                        <option value="crm-email-templates">Email Templates</option>
                                                                                                                        <option value="crm-sms-templates">SMS Templates</option>
                                                                                                                        <option value="crm-custom-templates">Custom Templates</option>
                                                                                                                        <option value="crm-system-setting">Company Details</option>
                                                                                                                        <option value="crm-email-setting">Email Settings</option>
                                                                                                                        <option value="system-configuration">System Setting</option>
                                                                                                                        <option value="clients">Clients</option>
                                                                                                                        <option value="super_components">Components</option>
                                                                                                                        <option value="super_modules">Modules</option>
                                                                                                                        <option value="super_packages">Packages</option>
                                                                                                                        <option value="open_ai_setting">AI Demo</option>
                                                                                                                        <option value="ringless-voicemail">Ringless Voicemail</option>
                                                                                                                        <option value="ringless-voicemail-campaign">Campaign</option>
                                                                                                                        <option value="ringless-list">Lists</option>
                                                                                                                        <option value="ringless-payment-method">Payment</option>
                                                                                                                        <option value="ringless-recharge">Recharge</option>
                                                                                                                        <option value="ringless-report">Report</option>
                                                                                                                        <option value="ringless-wallet-amount">Balance</option>
                                                                                                                        <option value="ringless-wallet-transactions">Wallet Transactions</option>
                                                                                                                        <option value="ringless-voice">Voice Template</option>
                                                                                                                        <option value="sip-gateways">SIP Gateways</option>
                                                                                                                        <option value="do-not-call">Do Not Call</option>
                                                                                                                        <option value="dnc">DNC</option>
                                                                                                                        <option value="exclude-from-list">Exclude From List</option>
                                                                                                                        <option value="sms-ai-campaign">Campaign</option>
                                                                                                                        <option value="sms-ai-list">Lists</option>
                                                                                                                        <option value="sms-ai-report">Reports</option>
                                                                                                                        <option value="sms-ai-templates">SMS AI Templates</option>
                                                                                                                        <option value="sms-ai-recharge">Recharge</option>
                                                                                                                        <option value="sms-ai-payment-method">Payment</option>
                                                                                                                        <option value="sms-ai-wallet-transactions">Wallet Transactions</option>
                                                                                                                        <option value="sip-trunking">Sip Trunk</option>
                                                                                                                        <option value="trunking-call-report">Report</option>
                                                                                                                        <option value="trunking-recharge">Recharge</option>
                                                                                                                        <option value="trunking-payment-method">Payment</option>
                                                                                                                        <option value="trunking-balance">Balance</option>
                                                                                                                        <option value="chat-ai">Chat AI</option>
                                                                                                                        <option value="chat-ai-setting">Chat AI Demo</option>
                                                                                                                        <option value="mailbox">Mailbox</option>
                                                                                                                        <option  value="sms">SMS</option>
                                                                                                                        <option  value="inbox">Inbox</option>
                                                                                                                        <option value="sms-templete">Text Template</option>
                                                                                                                        <option value="configuration-sms">Configuration</option>
                                                                                                                        <option value="schedule">Schedule</option>
                                                                                                                        <option value="receive-fax">Fax</option>
                                                                                                                        <option value="marketing-campaigns">Marketing Campaigns</option>
                                                                                                                        <option value="Conferences">Conferencing</option>
                                                                                                                        <option value="conferencing">Conferencing</option>
                                                                                                                        <option value="live-conference">Live Conferencing</option>
                                                                                                                        <option value="recording-conference">Recording Conferencing</option>
                                                                                                                        <option value="billing">Billing</option>
                                                                                                                        <option value="invoice">Invoice</option>
                                                                                                                        <option value="recharge">Recharge</option>
                                                                                                                        <option value="statement">Statement</option>
                                                                                                                        <option value="wallet-transactions">Wallet Transactions</option>
                                                                                                                        <option value="payment-method-list">Payment Methods</option>
                                                                                                                        <option value="super-admins">Super Admins</option>
                                                                                                                        <option value="subscription">Subscriptions</option>
                                                                                                                        <option value="active-plans">Active plans</option>
                                                                                                                        <option value="packages">Manage Packages</option>
                                                                                                                        <option value="plan-history">Plan History</option>
                                                                                                                        <option value="user-packages">User Packages</option>
                                                                                                                    </select></div>
                                            </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Attribute</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Order</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Is Active</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select id="multiple_labels" className="form-select">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  onClick={() => setOpenModal2(true)}
                >
                Reset
                </button>
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="offcanvas"
                >
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Calls */}
        {/* Delete Calls */}
        <div className="modal fade" id="delete_calls" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Confirm Delete</h4>
                  <p className="mb-0">You are about to delete record.</p>
                  <p className="mb-0">Do you want to proceed?</p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Calls */}
      </>
    </>
  );
};

export default Modules;
